import { render } from "./DipendentiComponent.vue?vue&type=template&id=77a3b2d6"
import script from "./DipendentiComponent.vue?vue&type=script&lang=js"
export * from "./DipendentiComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__